import { track } from "jiffy-analytics";
import { track as rudderstackTrack } from "common/utils/rudderstack/tracker";
import EventClass from "common/utils/ui/event-class";

// eslint-disable-next-line import/prefer-default-export
export class ProductFilterLinkClass extends EventClass {
  #urls = new Map();

  #linkSelector = "";

  constructor(props) {
    super(props);

    this.#linkSelector = props.eventSelector;
  }

  static $input($target) {
    return $target.querySelector("input");
  }

  static updateCheckedState($target) {
    const $input = ProductFilterLinkClass.$input($target);
    if (!$input) return;

    const isChecked = $input.checked;
    if ($input.type === "checkbox") {
      if (isChecked) {
        $input.removeAttribute("checked");
        $input.checked = false;
      } else {
        $input.setAttribute("checked", "checked");
        $input.checked = true;
      }
    } else if ($input.type === "radio") {
      const radios = document.querySelectorAll(`input[name="${$input.name}"]`);
      radios.forEach($radio => {
        if ($radio === $input) {
          $radio.setAttribute("checked", "checked");
        } else {
          $radio.removeAttribute("checked");
        }
        $radio.checked = $radio === $input; // eslint-disable-line no-param-reassign
      });
    }
  }

  get $links() {
    return document.querySelectorAll(this.#linkSelector);
  }

  get #serializedQueryURL() {
    const url = new URL("/", window.location.origin);
    url.search = Array.from(this.$links)
      .reduce((acc, $link) => {
        const $input = ProductFilterLinkClass.$input($link);
        if ($input?.checked) {
          return `${acc}${$input.name}=${encodeURIComponent($input.value)}&`;
        }
        return acc;
      }, "")
      .replace(/&$/, "");
    return url.toString();
  }

  get #activeFilterItems() {
    const urls = Array.from(this.#urls.entries());
    return Array.from(this.$links).filter($link => {
      const $input = ProductFilterLinkClass.$input($link);
      return urls.some(([name, url]) => $input?.name === name && url === $link.href);
    });
  }

  manualSubmit() {
    this.#activeFilterItems.forEach(ProductFilterLinkClass.sendClickEvent);
    const urls = Array.from(this.#urls.values());
    window.location.href = urls.length === 1 ? urls[0] : this.#serializedQueryURL;
  }

  event(event, $target) {
    super.event(event, $target);

    event.preventDefault();
    event.stopPropagation();

    ProductFilterLinkClass.updateCheckedState($target);

    const $input = ProductFilterLinkClass.$input($target);
    this.#urls.set($input?.name, $target.href);
  }

  static sendClickEvent($target) {
    const { mixpanelEvent, mixpanelData } = $target.dataset;
    let parsedData;
    try {
      parsedData = JSON.parse(mixpanelData || "{}");
    } catch (error) {
      console.error("Failed to parse mixpanel data:", error);
      parsedData = {};
    }

    track(mixpanelEvent, parsedData);

    const $anyLineItem = document.querySelector(".js-item-details-tracker");
    const pageName = $anyLineItem?.dataset?.pageName;
    rudderstackTrack("Navigation Clicked", {
      destination: $target.href,
      is_app: Boolean(window.MOBILE_APP),
      location: pageName || window.location.pathname,
      platform: window.MOBILE_APP_PLATFORM || "web",
      text: parsedData.filter_name,
      type: "link",
      url: window.location.href,
      nav_type: "side_nav"
    });
  }
}
